import request from '@/utils/request'

/** 查询课程列表（弹窗选择用） */
export function listCourseForSelect(query) {
  return request({
    url: '/educational/course/listForSelect',
    method: 'get',
    params: query
  })
}

/** 查询课程列表 */
export function listCourse(query) {
  return request({
    url: '/educational/course/list',
    method: 'get',
    params: query
  })
}
